import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import { Grid, InputAdornment, TextField, Checkbox, Typography } from '@material-ui/core';
import { connect } from 'react-redux';
import { compose } from 'redux';

// CONSTANTS
import { ROUTE_PRIVACY_POLICY, ROUTE_TERMS_AND_CONDITIONS } from '@/constants/routes';
import { LOCATIONS_CHANNELS_EMAIL_PAGE } from '@/constants/locations';

// COMPONENTS
import Link from '@/components/Link';

// STYLES
import {
  GridContainer,
  Container,
  TitleContainer,
  Title,
  TermsContainer,
  TermsText,
  TermsLink,
} from '../styles';

const Email = ({
  t,
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  isOptional,
  partner,
  hideLinks,
}) => {
  const textOverwrites = partner?.text_overwrites || {};
  const showOptional = isOptional || (Cookies.get('show_optional') && !partner.id);
  return (
    <Container className="page-content mail-step step">
      <GridContainer container justifyContent="center" alignItems="center">
        <Grid item md={8} className="email-address">
          <TitleContainer>
            <Title variant="h4" align="center" component="h1">
              {textOverwrites.fmb_email_title || t('channels.email.title')}
              {showOptional && <span>&nbsp;(optional)</span>}
            </Title>
            <Typography variant="subtitle2" align="center">
              {!hideLinks ? (
                <>
                  {textOverwrites.fmb_email_subtitle1 || t('channels.email.subtitlePart1')}
                  &nbsp;
                  {textOverwrites.fmb_email_subtitle2 || t('channels.email.subtitlePart2')}
                </>
              ) : (
                <>
                  {textOverwrites.fmb_email_hidelinks_subtitle1 ||
                    t('channels.email.subtitlePart1')}
                  &nbsp;
                  {textOverwrites.fmb_email_hidelinks_subtitle2 ||
                    t('channels.email.subtitlePart2')}
                </>
              )}
            </Typography>
          </TitleContainer>
          <TextField
            name="email"
            type="email"
            autoComplete="email"
            className="m-b-30"
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.email && !!errors.email}
            helperText={touched.email && errors.email}
            placeholder={textOverwrites.fmb_email_input || t('inputs.email')}
            InputProps={{
              endAdornment: (
                <InputAdornment
                  className={Boolean(!errors.email) && !!values.email ? 'success' : ''}
                  position="start"
                >
                  <i className="icon-check" />
                </InputAdornment>
              ),
            }}
          />
          <TermsContainer className="terms-wrapper">
            <Checkbox
              className="m-r-10"
              name="terms"
              onChange={handleChange}
              checked={values.terms}
            />
            <TermsText className="noselect">
              {t('channels.email.terms')}{' '}
              <TermsLink
                underline="always"
                target="_blank"
                component={Link}
                to={ROUTE_TERMS_AND_CONDITIONS}
                location={LOCATIONS_CHANNELS_EMAIL_PAGE}
              >
                {t('buttons.termsOfService')}
              </TermsLink>
              &nbsp;
              {t('common.and')}{' '}
              <TermsLink
                underline="always"
                target="_blank"
                component={Link}
                to={ROUTE_PRIVACY_POLICY}
                location={LOCATIONS_CHANNELS_EMAIL_PAGE}
              >
                {t('buttons.privacyPolicy')}
              </TermsLink>
              .
            </TermsText>
          </TermsContainer>
        </Grid>
      </GridContainer>
    </Container>
  );
};

Email.defaultProps = {
  isOptional: false,
};

Email.propTypes = {
  t: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  isOptional: PropTypes.bool,
  partner: PropTypes.object.isRequired,
  hideLinks: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ app }) => ({
  hideLinks: app.hideLinks,
});

export default compose(connect(mapStateToProps), withTranslation(), React.memo)(Email);
